import { useQueryClient, useQuery } from '@tanstack/react-query';
import { AccountBillingService } from 'src/services/account-billing-information';

type UseGetAccountBillingInformationArgs = {
  customerId: string;
};

export const ACCOUNT_BILLING_INFORMATION_QUERY_KEY = 'accountBillingInformation';

export const useGetAccountBillingInformationQuery = ({
  customerId,
}: UseGetAccountBillingInformationArgs) => {
  const queryClient = useQueryClient();

  const queryKey = [ACCOUNT_BILLING_INFORMATION_QUERY_KEY, customerId];

  const {
    data: accountBillingInformation,
    isLoading,
    isError,
  } = useQuery({
    queryKey,
    queryFn: () => AccountBillingService.getAccountBillingInformation(customerId),
    staleTime: 0,
    enabled: !!customerId,
    placeholderData: () => queryClient.getQueryData(queryKey),
  });

  return { accountBillingInformation, isLoading, isError };
};
